module.exports = __webpack_public_path__ + "img/166.5b5b826e.jpg";